import { SamplesProPlan } from 'constants/brands';
import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';
import { Interval } from 'types/generated/subscriptionsApi';
import Plan from '../Plan/Plan';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';
import useStudioPlan from './useStudioPlan';

export type PlanSelectorProps = {
    frequency: Interval;
    activePlanCode?: string;
    handlePlanSelect: (code: string) => void;
    creditsNeeded?: number;
};

export const LineThrough = styled.span<{ hasLineThrough: boolean }>`
    ${({ hasLineThrough }) =>
        hasLineThrough &&
        `
        text-decoration: line-through;
        `};
`;

const StudioUsp = ({ frequency }: { frequency: Interval }) => (
    <ul>
        <li>
            <Trans>
                Everything in <strong>{SamplesProPlan}</strong> plus:
            </Trans>
        </li>
        <li>
            <Trans>Unlimited MP3 + 36 WAV masters per year</Trans>
        </li>
        <li>
            <Trans>Unlimited distribution</Trans>
        </li>
        <li>
            <Trans>
                40+ DAW must-have plugins, VSTs{' '}
                <LineThrough hasLineThrough={frequency === 'Monthly'}>
                    & courses ($2000 of extras)
                </LineThrough>
            </Trans>
        </li>
        <li>
            <Trans>Collaboration tools for musicians</Trans>
        </li>
    </ul>
);

const StudioPlan = () => {
    const {
        frequency,
        hasStudioPlan,
        hasSubscription,
        selectedPlan,
        studioCatalog,
        handlePlanSelect,
        getDiscountedPlan,
    } = useUpsellActionsContext();

    const {
        code,
        currency,
        info,
        monthlyEquivalentPrice,
        monthlyEquivalentSale,
        salePrice,
        subscriptionPrice,
        title,
    } = useStudioPlan({
        frequency,
        hasSubscription,
        studioCatalog,
        getDiscountedPlan,
    });

    if (hasStudioPlan) {
        return null;
    }

    return (
        <Plan
            activePlanCode={selectedPlan}
            code={code}
            currency={currency}
            frequency={frequency}
            isMostPopular={true}
            monthlyEquivalentPrice={monthlyEquivalentPrice}
            subscriptionPrice={subscriptionPrice}
            title={title}
            info={info}
            usp={<StudioUsp frequency={frequency} />}
            handlePlanSelect={handlePlanSelect}
            salePrice={salePrice}
            monthlyEquivalentSale={monthlyEquivalentSale}
        />
    );
};

export default StudioPlan;
